module.exports = __webpack_public_path__ + "img/f_g2_lacestaff.48ecd1be.jpg";